import { navigate } from '../../app/hashRoute';

export type AuthMode = 'login' | 'register';

/** Keep the mode in the account URL so Back and reload preserve the chosen capsule. */
export function openAccount(mode: AuthMode): void {
  navigate('/account');
  window.history.replaceState(window.history.state, '', `#/account?mode=${mode}`);
}

export function readAccountMode(): AuthMode {
  if (typeof window === 'undefined') return 'login';
  const query = window.location.hash.split('?')[1] ?? '';
  return new URLSearchParams(query).get('mode') === 'register' ? 'register' : 'login';
}
